<template>
  <!--Contact Section Start-->
  <section class="tj-contact-section" v-if="db">
    <jumbotron :h1="'Building Careers'" v-if="this.$route.fullPath!='/'" style="margin-top:-150px" />
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class="tj-heading-style">
            <h3>Careers</h3>
            <!-- <p>{{db.career.description}}</p> -->
            <p v-html="db.career.description">
              <!-- Add paragraph here -->
              <!-- Are you talented, polite and energetic? We are always looking for good fits for our company. At
              <br />Whittington Cars, our culture is everything and our customers know that! Whether you’re
              <br />applying for a driver’s position, as an operator, or for business development role, you’ll quickly
              <br />integrate a passionate and professional team always striving to improve and grow. Drop us an
              <br />email or reach out to us by phone to apply. -->
            </p>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-2"></div>
          <div class="col-sm-8">
            <img :src="db.career.image" alt srcset style="width: 100%;" />
          </div>
          <div class="col-sm-2"></div>
        </div>
      </div>
    </div>
  </section>
  <!--Contact Section End-->
</template>
<script>
import firebase from "firebase";
import mailer from "../services/mailer.service";
import jumbotron from "./jumbotron";
export default {
  data() {
    return {
      db: null,
      vehicleTypes: [
        {
          id: 1,
          title: "Saloon = 4 Passengers x Hand Luggage Only"
        },
        {
          id: 2,
          title: "Estate = 4 Passengers x 4 S/cases"
        },
        {
          id: 3,
          title: "MPV 6 Seater = 6 Passengers x 4 S/cases"
        }
      ],
      booking: {
        name: "",
        email: "",
        phoneNumber: "",
        pickupAddress: "",
        dropOffAddress: "",
        pickupDate: new Date(),
        pickupTime: "",
        dropOffDate: new Date(),
        returnDate: new Date(),
        vehicleTypeId: 0,
        returnTime: "",
        passengers: 4,
        luggage: 1,
        childSeat: false,
        specialInstructions: ""
      },
      submitted: false
    };
  },

  components: { jumbotron },
  mounted() {
    document.body.scrollTop = 0; // For Safari
    document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
    let that = this;
    var ref = firebase.database().ref();
    ref.on(
      "value",
      function(snapshot) {
        that.db = snapshot.val();
      },
      function(error) {
        // console.log("Error: " + error.code);
      }
    );
  },
  methods: {
    handleSubmit(e) {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          mailer
            .send({
              to: this.booking.email,
              from: this.db.productInfo.email,
              subject: "'Design Your Model S | Tesla'",
              html:
                "<h1>Have the most fun you can in a car!</h1><p>Get your <b>Tesla</b> today!</p>"
              // "attachments": [
              //   {
              //     "filename": "your-testla.png",
              //     "path": "https://media.gettyimages.com/photos/view-of-tesla-model-s-in-barcelona-spain-on-september-10-2018-picture-id1032050330?s=2048x2048"
              //   }
              // ]
            })
            .then(res => {
              alert(
                "Thank you for contacting us our support team will contact you soon."
              );
            });
        }
      });
    }
  }
};
</script>
<style scoped>
.invalid-feedback {
  color: red;
  padding-bottom: 15px;
}
.is-invalid {
  border: 0.5px solid red;
}
</style>